<template>
  <div class="home">
      
    <el-row>
      <!-- 文件件列表 -->
      <el-col :span="3" class="file_folder">
        <div class="grid-content bg-purple">
          <br/>
          <el-button @click="loginOut"  size="mini">退出登录</el-button>
          <br/><br/>
          <el-button @click="createPackage"  size="mini">新建文件夹</el-button>

          <div v-for="(item,k) in packages.list" :key="k" class="package-box" :class="[item.on]" @click="changePackage(k)">
            <div 
              class="package-ele-box" 
              :class="'package-ele-box-'+k"
              @dblclick="upNameFocus('.package-ele-box-'+k)">

              <div class="package-ele">
                <i class="el-icon-folder-opened" />&nbsp;
                <div class="ele-name">{{item.name}}</div>
              </div>

              <textarea 
                class="name-edit" 
                :class="'name-edit-'+k" 
                v-model="item.name" 
                @keyup="upNameKeyup($event)"
                @blur="upNameBlur('.package-ele-box-'+k,'package',item.id)"></textarea>
              
              
              <div class="edit-btns-box">
                <i class="el-icon-more"></i>
                <div class="edit-btns">
                  <div>
                    <div>
                      <div @click="upNameFocus('.package-ele-box-'+k)">重命名</div>
                      <div v-if="item.status==1" @click="upstatus('package',k)">取消公开</div>
                      <div v-if="item.status==0" @click="upstatus('package',k)">公开</div>
                      <div @click="delEle('package',k)">删除</div>
                    </div>
                    
                  </div>
                  
                </div>
                
              </div>

            </div>
          </div>

        </div>
      </el-col>
      <!-- 文件夹列表 -->
      <el-col :span="3" class="file_title">
        <div class="grid-content bg-purple">
          <!-- 添加文件按钮 -->
          <br/>
            <el-button  @click="createProject"  size="mini">新建文档</el-button>
          <!-- 文件列表 -->
          
          <div v-for="(vo,kk) in packages.list[packageIndex].projects.list" 
            :key="kk" 
            class="project-box" 
            :class="[vo.on]"
            @drag="dragProject($event,kk)"
          >
            <div class="project-ele-box" 
              :class="'project-ele-box-'+kk"
              @click="changeProject(kk)" 
              @dblclick="upNameFocus('.project-ele-box-'+kk)"
            >
              <div class="project-ele">
                <i class="el-icon-document" />&nbsp;
                <div class="ele-name">{{vo.name}}</div>
              </div>
              
              <textarea
                class="name-edit"
                :class="'name-edit-'+kk" 
                v-model="vo.name" 
                @keyup="upNameKeyup($event)"
                @blur="upNameBlur('.project-ele-box-'+kk,'project',vo.id)"></textarea>
              
              <div class="edit-btns-box">
                <i class="el-icon-more"></i>
                <div class="edit-btns">
                  <div>
                    <div>
                      <div @click="upNameFocus('.project-ele-box-'+kk)">重命名</div>
                      <div v-if="vo.status==1" @click="upstatus('project',kk)">取消公开</div>
                      <div v-if="vo.status==0" @click="upstatus('project',kk)">公开</div>
                      <div @click="delEle('project',kk)">删除</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </el-col>
      <!-- 编辑器【内容】 -->
      <el-col :span="18" class="file_content">
        <div class="grid-content bg-purple-light">

          <el-container>
            <el-main class="content-main">
              <div v-if="content" style="line-height: normal;min-height: 100vh;">
                <quill-editor
                  class="ql-editor"
                  v-model="content.content"
                  ref="quillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @change="onEditorChange($event)"
                >
                </quill-editor>
              </div>
            </el-main>
          </el-container>
          
          

        </div>
      </el-col>
    </el-row>

    
    <div class="up-box">
      <el-button @click="saveProject" type="primary"  size="mini">保存</el-button>
    </div>
  </div>
</template>

<script>

import { quillEditor } from 'vue-quill-editor' 
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import http from "../http"
import QS from "qs"
import common from "../common"

export default {
  name: 'Edit',
  components: {
    quillEditor
  },
  data () {
    return {
      packages: {
        list:[
            {
              id:0,
              name:"默认文件夹",
              updateTime:"2022-02-02",
              on:"on",
              projects:{
                list:[
                  {id:0,name:"默认文件",updateTime:"",on:"",package_id:1,content:""}
                 
                ],
                total:0,
                page:1
              }
            },
            
        ],
        total:10,
        page:1
      },
      
      content:{id:0,name:"默认文件",updateTime:"",on:"",package_id:1,content:"欢迎使用ux笔记，开始您的记录吧！！"},
      contenttest:{id:0,name:"默认文件",updateTime:"",on:"",package_id:1,content:"欢迎使用ux笔记，开始您的记录吧！！"},
      packageIndex:0,//当前文件夹索引
      projectIndex:0, //当前文件索引
      tmpname:"", // 要修改的名称获取焦点是的值，失去焦点是与其对比，如果没有修改就不请求接口保存
      tmpcontent:"",// 要修改的文本获取焦点是的值，失去焦点是与其对比，如果没有修改就不请求接口保存
      editorOption:{
        modules: {
        
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除�?
              ['code-block'],                     //引用，代码块['blockquote', 'code-block']
              [{ 'header': 1 }, { 'header': 2 }],               // 几级标�??
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],    // 有序列表，无序列�?
              [{ 'script': 'sub' }, { 'script': 'super' }],     // 下�?�标，上角标
              [{ 'indent': '-1' }, { 'indent': '+1' }],         // 缩进
              [{ 'direction': 'rtl' }],                         // 文字输入方向
              // [{ 'size': ['small', false, 'large', 'huge'] }],  // 字体大小
              // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],        // 标�??
              [{ 'color': [] }, { 'background': [] }],          // 颜色选择
              // [{ 'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }], // 字体
              [{ 'align': [] }],    // 居中
              ['clean'],            // 清除样式,
              // ['link', 'image']   // 上传图片、上传�?��??
            ],
            handlers: {
              insertMetric: this.showHandle
            }
          }
        }
      },
      
    }
  },
  mounted(){
    
    var _this = this

    console.log(this.packages)
    http.get(common.api.packageList+"?self=1").then(res=>{
      
      if(res.data.code==1 ){
       
        if(res.data.data.page==1){
      
          _this.packages = res.data.data
        }else{
       
          _this.packages.list = _this.packages.list.push.apply(_this.packages.list,res.data.data.list)
          
        }
      
        _this.packages.total = res.data.data.total
        _this.packages.page = res.data.data.page

        
      }
    
      _this.content = _this.packages.list[0].projects.list[0]
      _this.packages.list[0].on = "on"
      _this.packages.list[0].projects.list[0].on = "on"

    }).catch(err=>{
      console.log("axios error")
    })

    document.onkeyup=function(e){
      console.log(e.keyCode)
      if(e.keyCode==86 && e.ctrlKey){
        console.log("sss")
        var ele = document.querySelector(".ql-editor")

        console.log(ele)
        // ele.setSelectionRange(textArea.value.length, textArea.value.length) 

      }
    }
  },
  methods: {
    onEditorBlur (quill) {
     
      // var tmp = this.content.content
      // if(tmp!=this.tmpcontent){
      //   this.saveProject()
      // }
      
    },
    onEditorFocus (quill) {
 
      console.log('editor focus!', quill)
      this.tmpcontent = this.content.content
    },
    onEditorChange (quill) {
      
      console.log('editor ready!', quill)
    },
    // 创建文件夹
    createPackage(){
      var _this = this
      var data = new Object()
      data['name']="新建文件夹";
      
      http.post(common.api.upPackage,QS.stringify(data)).then(res=>{
       
        if(res.data.code==1){
          var tmp = {
            id:parseInt(res.data.data),
            name:data['name'],
            updateTime:"",
            on:"",
            projects:{
              list:[
              ],
              total:0,
              page:1
            }
          }
          _this.packages.list.push(tmp)
        }
      })
    },
    // 切换文件夹
    changePackage(k){
      // 样式切换
      this.packages.list[this.packageIndex].on="";
      this.packages.list[k].on="on";

      // 数据切换
      this.packageIndex=k
      this.projectIndex = 0
      console.log(this.packageIndex)
    },
    // 创建新文件
    createProject(){
      var _this = this
      var data = new Object()
      data.name="新建文件";
      data.package_id = this.packages.list[this.packageIndex].id
  
      http.post(common.api.upProject,QS.stringify(data)).then(res=>{
        
    
      
        if(res.data.code==1){
          var tmp = {
            id:parseInt(res.data.data),
            name:data['name'],
            updateTime:"",
            on:"",
            content:""
          }
          _this.packages.list[_this.packageIndex].projects.list.push(tmp)
        }
        console.log(_this.packages)
      })
    },
    // 切换文件
    changeProject(kk){
      
      this.packages.list[this.packageIndex].projects.list.map(res=>{
        if(res.on=="on"){
          res.on=""
        }
      })
      this.packages.list[this.packageIndex].projects.list[kk].on="on"
     
      this.content=this.packages.list[this.packageIndex].projects.list[kk]

      this.projectIndex = kk
      
    },
    
    // 文件夹或文件获取焦点，准备修改
    upNameFocus(clas){
    
      var ele = document.querySelector(clas)
      ele.classList.add("edit")
      this.tmpname = ele.querySelector(".ele-name").innerText
      console.log(ele)
      var textArea = ele.querySelector(".name-edit")
      textArea.focus()
    
      textArea.setSelectionRange(textArea.value.length, textArea.value.length) //光标定位到末尾
          
      
    },
    upNameKeyup(e){
      if(e.keyCode==13){
        e.target.blur()
      }
     
    },
    // 文件夹或文件失去焦点，修改
    upNameBlur(clas,type,id){
      var ele = document.querySelector(clas)
      ele.classList.remove("edit")
      var tmp = ele.querySelector(".ele-name").innerText
      tmp = tmp.replace(/(^\s*)|(\s*$)/g, "");
      // 保存数据
      if(tmp!=this.tmpname){
        if(type=="project"){
          this.saveProject()
        }else{
          this.savePackage(id)
        }
      }
    },
    // 保存文件夹数据
    savePackage(id){
      var tmp = this.packages.list.find(res=>res.id==id)
      var data = new Object()
      data.id=tmp.id
      data.name=tmp.name
      data.on=tmp.on
      http.post(common.api.upPackage,QS.stringify(data)).then(res=>{

      })

    },
    // 保存文件数据
    saveProject(){
      var data = this.content
      var _this = this
      http.post(common.api.upProject,QS.stringify(data)).then(res=>{
        _this.$message(res.data.msg)
      })
    },
    loginOut(){
      var _this = this
      http.get(common.api.quit).then(res=>{
        _this.$router.push({path:"login"})
      })
    },
    rename(type,k){
      switch(type){
        case "package":

          break;
        default:

          break;
      }
    },
    delEle(type,k){
      switch(type){
        case "package":
          var data = new Object()
          data.id = this.packages.list[k].id

          if(data.id>0){
            data.status=-1
            var _this = this
            http.post(common.api.upPackage,QS.stringify(data)).then(res=>{
              if(res.data.code==1){
                _this.packages.list.splice(k,1);

                if(_this.packageIndex>=_this.packages.list.length){
                  _this.packageIndex = 0
                }
              }
            })
          }
          break;
        default:
          var data = new Object()
          console.log("k:"+k)
          data.id = this.packages.list[this.packageIndex].projects.list[k].id

          if(data.id>0){
            data.status=-1
            var _this = this
            http.post(common.api.upProject,QS.stringify(data)).then(res=>{
              if(res.data.code==1){
                _this.packages.list[_this.packageIndex].projects.list.splice(k,1);

                if(_this.projectIndex>=_this.packages.list[_this.packageIndex].projects.list.length){
                  _this.projectIndex = 0
                }
              }
            })
          }
          break;
      }
    },

    upstatus(type,k){
      console.log(k)
      switch(type){
        case "package":
          var data = new Object()
          data.id = this.packages.list[k].id

          if(data.id>0){
            if(this.packages.list[k].status==1){
              data.status=0
            }else{
              data.status=1
            }
            var _this = this
            http.post(common.api.upPackage,QS.stringify(data)).then(res=>{
              if(res.data.code==1){
                _this.packages.list[k].status = data.status
              }
            })
          }
          break;
        default:
          var data = new Object()
          
          data.id = this.packages.list[this.packageIndex].projects.list[k].id

          if(data.id>0){
            if(this.packages.list[this.packageIndex].projects.list[k].status==1){
              data.status=0
            }else{
              data.status=1
            }
            var _this = this
            http.post(common.api.upProject,QS.stringify(data)).then(res=>{
              if(res.data.code==1){
                _this.packages.list[this.packageIndex].projects.list[k].status = data.status
              }
            })
          }
          break;
      }
    },
    dragProject(e,k){
      console.log("====")
      console.log(k)
      console(e.target)
    }

  },
}
</script>


<style scoped>
  .home{
    min-width: 1150px;
    margin:auto
  }
  .file_title{
    min-height: 100vh;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    border-right: 1px solid rgba(0, 0, 0, 0.2);
  }
  .content-main{
    height: calc(100vh - 10px);
    padding: 0
  }
  .ql-editor{
    padding:0px 0px;
    min-height: 100vh;
    margin-top: -24px;
    margin-left:-1px
  }
  .package-ele,.project-ele{
    margin:10px 10px;
    padding:10px 10px;
    text-align:left;
    display: flex;
    justify-content: left;
    cursor:pointer;
  }
 
  .package-box.on .package-ele,
  .project-box.on .project-ele{
    background: rgba(0, 0, 0, 0.1);
  }

 .package-ele-box,
  .project-ele-box{
    position: relative;
  }
.name-edit{
  position: absolute;
  top:12px;
  left:40px;
  width:67%;
  outline: none;
  background: rgba(0, 0, 0, 0);
  border:0px;
  display: none;
 }
 .ele-name{
  word-break: break-all;
  font-size: 14px;
 }
 .package-ele-box.edit .ele-name,
 .project-ele-box.edit .ele-name{
  display:none
 }
 .package-ele-box.edit .name-edit,
 .project-ele-box.edit .name-edit{
    display: block;
 }
 .edit-btns-box{
  position: absolute;
  top:12px;
  right: 3px;
  font-size: 14px;
  z-index: 9;
  display: none;


 }
  .edit-btns-box i{
      transform: rotateZ(90deg);
  }
 .edit-btns div{
  cursor: pointer;
 }
 .package-ele-box:hover .edit-btns-box,
 .project-ele-box:hover .edit-btns-box{
  display: block;
 }
 .edit-btns{
  display: none;
  /* transform: rotateX(-90deg); */
 }
 .edit-btns>div{
  position: relative;
 }
  .edit-btns>div>div{
    position: absolute;
    width: 60px;
    top: -15px;
    left: 10px;
    padding:5px 10px;
    background-color: cadetblue;
    text-align: left;
    line-height: 25px;
  }
 .edit-btns-box:hover .edit-btns{
  display: block;
 }
 .up-box{
  position: fixed;
  top:10px;
  right: 32px;
  z-index: 9;
 }
</style>



// WEBPACK FOOTER //
// src/components/Edit.vue